export const POM_CENTER = [-9.4438, 147.1803];

export const PLACES = [
  { name: "Jacksons International Airport", lat: -9.4434, lng: 147.22 },
  { name: "Waigani (Government Offices)", lat: -9.4248, lng: 147.1856 },
  { name: "Vision City Mall, Waigani", lat: -9.4269, lng: 147.1915 },
  { name: "Boroko", lat: -9.4671, lng: 147.1983 },
  { name: "Gordons", lat: -9.437, lng: 147.196 },
  { name: "Downtown Town", lat: -9.479, lng: 147.15 },
  { name: "Ela Beach", lat: -9.4825, lng: 147.153 },
  { name: "Koki Market", lat: -9.476, lng: 147.165 },
  { name: "Badili", lat: -9.476, lng: 147.175 },
  { name: "Konedobu", lat: -9.472, lng: 147.142 },
  { name: "Hohola", lat: -9.445, lng: 147.17 },
  { name: "Tokarara", lat: -9.43, lng: 147.165 },
  { name: "University of PNG", lat: -9.413, lng: 147.174 },
  { name: "Gerehu", lat: -9.392, lng: 147.17 },
  { name: "6 Mile", lat: -9.452, lng: 147.212 },
  { name: "9 Mile", lat: -9.41, lng: 147.235 },
];

export function nearestPlace(lat, lng) {
  let best = PLACES[0];
  let bestD = Infinity;
  PLACES.forEach((p) => {
    const d = (p.lat - lat) ** 2 + (p.lng - lng) ** 2;
    if (d < bestD) {
      bestD = d;
      best = p;
    }
  });
  return `Pinned near ${best.name}`;
}
